//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vakgroepPost from '~/graphql/queries/vakgroepPost.gql';
import deleteVakgroepPost from '~/graphql/mutations/deleteVakgroepPost.gql';
import publishVakgroepPost from '~/graphql/mutations/publishVakgroepPost.gql';

export default {
  auth: false,
  apollo: {
    vakgroepPost: {
      query: vakgroepPost,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data: () => ({
    vakgroepPost: {},
    userUuid: false,
    isAdmin: false,
    placeholderImage: require('~/assets/img/post_placeholder.png'),
  }),
  computed: {
    columnSplitImages() {
      let lastColumn = 1;

      const left = [];
      const right = [];
      if (this.vakgroepPost && this.vakgroepPost.images.length) {
        this.vakgroepPost.images.forEach((image, index) => {
          if (lastColumn === 1) {
            lastColumn = 0;
            left.push({image, index, type: 'new'});
          } else {
            lastColumn = 1;
            right.push({image, index, type: 'new'});
          }
        });
      }

      return [
        left,
        right,
      ];
    },
  },
  mounted() {
    this.userUuid = this.$auth.loggedIn ? this.$auth.user.uuid : null;
    this.isAdmin = this.$auth.loggedIn ? this.$auth.user.is_admin : false;
  },
  methods: {
    async deletePost() {
      if (confirm('Weet je zeker dat je deze bericht wilt verwijderen?')) {
        try {
          await this.$apollo.mutate({
            mutation: deleteVakgroepPost,
            variables: {
              slug: this.$route.params.slug,
            },
          }).then(() => {
            this.$toast.success('Het bericht is verwijderd.');
            this.$router.push({name: 'van-en-voor-leden'});
          });
        } catch (e) {
          this.$toast.error(e);
        }
      }
    },
    async publishPost() {
      if (confirm('Weet je zeker dat je deze bericht wilt gaan publiceren?')) {
        try {
          await this.$apollo.mutate({
            mutation: publishVakgroepPost,
            variables: {
              slug: this.$route.params.slug,
            },
            refetchQueries: [{
              query: vakgroepPost,
              fetchPolicy: 'network-only',
              variables: {slug: this.$route.params.slug},
            }],
          }).then(() => {
            this.$toast.success('Het bericht is gepubliceerd.');
          });
        } catch (e) {
          this.$toast.error(e);
        }
      }
    },
  },
};
